import axios from 'axios';

export const openPortail = async () => {
    const formData = new FormData();
    formData.append('id', 'e465b8faf008');
    formData.append('channel', '0');
    formData.append('turn', 'on');

    const config = {
        method: 'post',
        maxBodyLength: Infinity,
        url: `https://shelly-149-eu.shelly.cloud/device/relay/control?auth_key=MmJiMGVidWlkF1AFF531A387772788D9646212AF0B0F500587C499BC6294B3D021A2C6DAF16592B5B145AF45F598`,
        data: formData
    };

    try {
        const response = await axios.request(config);
        console.log('Relay controlled:', JSON.stringify(response.data));
    } catch (error) {
        console.error('Error controlling relay:', error);
    }
};
